// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"862":"4b00aa92","943":"a1620ede"}[chunkId] + ".chunk.js";
};